module.exports = __webpack_public_path__ + "static/media/200009_leereenheden.40f1e495.jpg";